import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Dialog, DialogHeader, DialogPopup, DialogTitle } from '../../../web/components-v2/Dialog';
import { BrandSettingsSection } from '../../../web/components/settings/AdminSettings/BrandSettingsSection';
import { styles } from './styles';

export interface IBrandSettingsModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	account?: Api.IAccount;
}

/**
 * Modal for managing brand settings (admin/impersonation context).
 * Uses Dialog from components-v2 with controlled open state.
 */
export const BrandSettingsModal: React.FC<IBrandSettingsModalProps> = ({ open, onOpenChange, account }) => {
	const impersonationContext = React.useMemo(() => ({ account }), [account]);

	return (
		<Dialog open={open} onOpenChange={onOpenChange} dismissOnOutsideClick={false}>
			<DialogPopup>
				<div className={css(styles.container)}>
					<DialogHeader>
						<div className={css(styles.header)}>
							<DialogTitle>Brand Settings</DialogTitle>
						</div>
					</DialogHeader>
					<section className={css(styles.content)}>
						<BrandSettingsSection impersonationContext={impersonationContext} />
					</section>
				</div>
			</DialogPopup>
		</Dialog>
	);
};
